let projects = {
	init: function(){
		pSlide.init();
		projects.nav();
		projects.setNum();
	},
	nav: function(){
		let $tip = $(".modal_tips");
		$("a.show_tip").off().on("click", function(){
			if( !$tip.hasClass("active") ){
				$tip.addClass("active");
			}else{
				$tip.removeClass("active");
			}
		});
		$("a.btn_close_tip").off().on("click", function(){
			if( $tip.hasClass("active") ){
				$tip.removeClass("active");
			}
		});
		$("a.btn_viewmore").off().on("click", function(e){
			e.preventDefault();
			let lang = $(this).attr("data-lang");
			let $block = "";
			if(lang === "jp"){
				$block = $(".content_extend_jp");
			}else if(lang === "en"){
				$block = $(".content_extend_en");
			}else{
				//両方
				$block = $(".content_extend_jp, .content_extend_en");
			}
			console.log($block);
			$(this).remove();
			$block.find(".inner").animate({
				height: "toggle", opacity: "toggle"
			}, 400);
		});
	},
	setNum: function(){
		/*
		let $yield = $("#project_outline .list_spec dl").eq(3);
		let num = $yield.attr("data-num");
		
		let HTML = "";
		for(var i = 0; i < num.length; i++){
			let n = num[i];
			if(n === "."){
				HTML += `<div class="n n${n} dot"><span class="dot">.</span></div>`;
			}else{
				HTML += `<div class="n n${n}"><span class="non"></span><span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span></div>`
			}
		}
		$yield.find(".nums").html(HTML);
		*/
	}
}
let pSlides = [];
let pTimer = "";
let Slide = {
	count: 0,
	max: 0,
	mouse: [0, 0],
	duration: 5000,
	startTime: 0,
	endTime: 0,
	timer: ""
}
let pSlide = {
	count: 0,
	max: 0,
	mouse: [0, 0],
	duration: 5000,
	startTime: 0,
	endTime: 0,
	init: function(){
		pSlides = [];
		$(".img_slideshow").each(function(j){
			let _s 		= object(Slide);
			_s.count 	= 0;
			_s.max 		= $(this).find("li").length;
			_s.mouse 	= [0,0];
			_s.duration = 5000;
			_s.startTime = 0;
			_s.endTime 	= 0;
			_s.timer 	= "";
			pSlides.push(_s);
			if(_s.max != 1){
				let navHTML = "";
				for(let d = 0; d < _s.max; d++){
					navHTML += `<li><a href="javascript:void(0);" data-index="${d}"><span>${d}<span></a></li>`;
				}
				$(".nav_slideshow ul").html(navHTML);
			}else{
				$(".nav_slideshow ul").remove();
				$(".img_slideshow").eq(j).find(".btn_slideshow").addClass("disable");
			}
		});
		
		for(let i = 0; i < pSlides.length; i++){
			pSlide.change(i);
			pSlide.update();
			pSlide.mouse(i);
		}
		
		pSlide.nav();
	},
	update: function(){
		pTimer 	= requestAnimationFrame( pSlide.update );
		let now 		= new Date();
		let currentTime = now.getTime();
		for(var i = 0; i < pSlides.length; i++){
			if(pSlides[i].max != 1){
				let diff 		= pSlides[i].endTime - currentTime;
				let per 		= diff/pSlides[i].duration;
				$(".nav_slideshow").eq(i).find("ul li").eq(pSlides[i].count).find("span").css({
					"width": (1 - per)*100 + "%"
				});
				if( currentTime >= pSlides[i].endTime ){
					pSlide.inc(i);
				}
			}
			
		}
	},
	nav: function(){
		$(".nav_slideshow ul li a").off().on("click", function(){
			let idx = $(this).attr("data-index");
			pSlides[idx].count = $(".nav_slideshow ul li a").eq(idx).index(this);
			pSlide.change(idx);
		});
		$(".btn_slideshow a.btn_next").off().on("click", function(){
			let idx = $(this).attr("data-index");
			pSlide.inc(idx);
		});
		$(".btn_slideshow a.btn_prev").off().on("click", function(){
			let idx = $(this).attr("data-index");
			pSlide.dec(idx);
		});
		let startX, diffX, idx;
		for(var i = 0; i < pSlides.length; i++){
			let idx = i;
			$(".btn_slideshow").eq(i)[0].addEventListener("touchstart", function(e){
				startX = e.touches[0].pageX;
				console.log(startX, e);
			}, false);
			$(".btn_slideshow").eq(i)[0].addEventListener("touchmove", function(e){
				diffX = startX - e.touches[0].pageX;
			}, false);
			$(".btn_slideshow").eq(i)[0].addEventListener("touchend", function(e){
				startX = 0;
				if(diffX >50){
					pSlide.inc(idx);
				}else{
					pSlide.dec(idx);
				}
				diffX = 0;
			}, false);
			$(".btn_slideshow").eq(i)[0].addEventListener("touchcancel", function(e){
				startX = 0;
				diffX = 0;
			}, false);
		}
		/*
		function touchstart(e){
			startX = e.touches[0].pageX;
			console.log(startX, e);
		}
		function touchmove(e){
			diffX = startX - e.touches[0].pageX;
		}
		function touchend(e){
			startX = 0;
			if(diffX >50){
				pSlide.inc();
			}else{
				pSlide.dec();
			}
			diffX = 0;
		}
		function touchcancel(){
			startX = 0;
			diffX = 0;
		}
		*/
	},
	inc: function(idx){
		let p = pSlides[idx];
		p.count++;
		if(p.count >= p.max){
			p.count = 0;
		}
		pSlide.change(idx);
	},
	dec: function(idx){
		let p = pSlides[idx];
		p.count--;
		if(p.count < 0){
			p.count = p.max-1;
		}
		pSlide.change(idx);
	},
	change: function(idx){
		let $thisSlide = $(".img_slideshow").eq(idx);
		$thisSlide.find("ul li").removeClass();
		$thisSlide.find("ul li").eq(pSlides[idx].count).addClass("active");
		$(".nav_slideshow").eq(idx).find("ul li").each(function(i){
			let $this = $(this);
			if(i < pSlides[idx].count){
				$this.find("span").css("width", "100%");
			}else{
				$this.find("span").css("width", "0%");
			}
		});
		let date = new Date();
		pSlides[idx].startTime 	= date.getTime();
		pSlides[idx].endTime 	= pSlides[idx].startTime + pSlides[idx].duration;
	},
	mouse: function(idx){
		let $area = $(".btn_slideshow").eq(idx);
		let $icon = $(".icon_nav").eq(idx);
		$area[0].removeEventListener("mousemove", getMousePos, false);
		$area[0].addEventListener("mousemove", getMousePos, false);
		function getMousePos(e){
			let w = $area.width();
			let l = $area.offset().left;
			let end = l + w;
			let half = (w + l) / 2;
			
			pSlides[idx].mouse[0] = e.clientX;
			pSlides[idx].mouse[1] = e.clientY - $area.offset().top;
			
			if(pSlides[idx].mouse[0] < half){
				if( !$icon.hasClass("left") ){
					$icon.removeClass("right");
					$icon.addClass("left");
				}
			}else{
				if( !$icon.hasClass("right") ){
					$icon.removeClass("left");
					$icon.addClass("right");
				}
			}
			$area.find(".icon_nav").css({
				"top": pSlides[idx].mouse[1] + "px",
				"left": e.clientX - $area.offset().left + "px"
			});
		}
	},
	reset: function(idx){
		cancelAnimationFrame(pSlides[idx].timer);
	}
}